import i18n from '@/i18n.ts';
import { get, post, put, del } from '@/api/apiService.ts';
import type {
  KnowledgeCategory,
  KnowledgeArticle,
  KnowledgeSearchResult,
  CreateKnowledgeCategory,
  CreateKnowledgeArticle,
} from '@/types/knowledgeBook.ts';

function langParam(): string {
  return `lang=${i18n.language.split('-')[0]}`;
}

const knowledgeService = {
  getCategories(): Promise<KnowledgeCategory[]> {
    return get<KnowledgeCategory[]>(`/api/knowledge/categories?${langParam()}`);
  },

  getArticles(categorySlug: string): Promise<KnowledgeArticle[]> {
    return get<KnowledgeArticle[]>(`/api/knowledge/categories/${categorySlug}/articles?${langParam()}`);
  },

  getArticle(categorySlug: string, articleSlug: string): Promise<KnowledgeArticle> {
    return get<KnowledgeArticle>(
      `/api/knowledge/categories/${categorySlug}/articles/${articleSlug}?${langParam()}`,
    );
  },

  search(query: string): Promise<KnowledgeSearchResult[]> {
    return get<KnowledgeSearchResult[]>(
      `/api/knowledge/search?q=${encodeURIComponent(query)}&${langParam()}`,
    );
  },

  // Admin CRUD
  createCategory(data: CreateKnowledgeCategory): Promise<KnowledgeCategory> {
    return post<CreateKnowledgeCategory, KnowledgeCategory>('/api/knowledge/categories', data);
  },

  updateCategory(id: string, data: CreateKnowledgeCategory): Promise<KnowledgeCategory> {
    return put<CreateKnowledgeCategory, KnowledgeCategory>(`/api/knowledge/categories/${id}`, data);
  },

  deleteCategory(id: string): Promise<void> {
    return del<void>(`/api/knowledge/categories/${id}`);
  },

  createArticle(categoryId: string, data: CreateKnowledgeArticle): Promise<KnowledgeArticle> {
    return post<CreateKnowledgeArticle, KnowledgeArticle>(`/api/knowledge/categories/${categoryId}/articles`, data);
  },

  updateArticle(articleId: string, data: CreateKnowledgeArticle): Promise<KnowledgeArticle> {
    return put<CreateKnowledgeArticle, KnowledgeArticle>(`/api/knowledge/articles/${articleId}`, data);
  },

  deleteArticle(articleId: string): Promise<void> {
    return del<void>(`/api/knowledge/articles/${articleId}`);
  },
};

export default knowledgeService;
